export const isURLActive = (url) => window.location.href.indexOf(url) !== -1;
//# sourceMappingURL=isURLActive.js.map